import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { DataTableDirective } from 'angular-datatables';
import { Config } from 'datatables.net-dt';
import { Subject } from 'rxjs';
import { AuthService } from 'src/app/auth/_service/auth.service';
import { ApiService } from 'src/app/shared/_service/api.service';

@Component({
	selector: 'app-handle-containers',
	templateUrl: './handle-containers.component.html',
})
export class HandleContainersComponent implements OnInit, OnDestroy {
	constructor(
		public router: Router,
		public api: ApiService,
		public auth: AuthService,
	) {}

	@ViewChild(DataTableDirective, { static: false })
	dtElement: DataTableDirective;

	isAdminOrBackoffice = this.auth.isAdminOrBackoffice;
	isSpedizioniere = this.auth.isSpedizioniere;
	isCliente = this.auth.isCliente;

	dtTrigger = new Subject();
	dtSettings: Config = {
		columnDefs: [
			{ searchable: true, targets: 0, orderable: true },
			{ searchable: true, targets: 1, orderable: true },
			{ searchable: false, targets: 2, orderable: true },
			{ searchable: false, targets: 3, orderable: true },
			{ searchable: false, targets: 4, orderable: false },
		],
	};

	spedizioni: any[] = [];

	ngOnInit() {
		this.api.getSpedizioni().subscribe((spedizioni: any) => {
			this.spedizioni = spedizioni;
			if (this.isAdminOrBackoffice) {
				this.spedizioni = this.spedizioni.filter((s) => s.chiusa || s.tipoSpedizione == 'ORDINE_IN_SPEDIZIONE');
			}
			this.dtTrigger.next();
		});
	}

	ngOnDestroy(): void {
		this.dtTrigger.unsubscribe();
	}

	showCloseToggle(spedizione) {
		return this.isAdminOrBackoffice || (this.isCliente && spedizione.tipoSpedizione !== 'ORDINE_IN_SPEDIZIONE');
	}

	showRemove(spedizione) {
		return this.isAdminOrBackoffice || (this.isCliente && spedizione.tipoSpedizione !== 'ORDINE_IN_SPEDIZIONE');
	}

	delete(spedizione) {
		this.api.deleteSpedizione({ idSpedizione: spedizione.id }).subscribe((res: any) => {
			if (res.esito === 'OK') {
				this.spedizioni.splice(this.spedizioni.indexOf(spedizione), 1);
				this.renderTable();
			}
		});
	}

	chiudiApriSpedizione(spedizione) {
		this.api.toggleChiudiSpedizione({ idSpedizione: spedizione.id }).subscribe((newSpedizione: any) => {
			this.spedizioni.splice(this.spedizioni.indexOf(spedizione), 1, newSpedizione);
		});
	}

	renderTable() {
		this.dtElement.dtInstance.then((dtInstance: any) => {
			dtInstance.destroy();
			this.dtTrigger.next();
		});
	}

	sameUser(user) {
		return user.id === this.auth.getUser().id;
	}

	setStatoInSpedizione(spedizione) {
		this.api
			.saveSpedizione({
				...spedizione,
				idOrdine: spedizione.ordine.id,
				idSpedizione: spedizione.id,
				tipoSpedizione: 'ORDINE_IN_SPEDIZIONE',
			})
			.subscribe((s) => this.spedizioni.splice(this.spedizioni.indexOf(spedizione), 1, s));
	}
}
